<template>
  <template v-if="!contentId">
    <PageTitle
      title="Contents"
      :description="`Key Information and Trending Topics of the ${CHAIN}`"
    />
    <ContentTab class="px-4" />
    <Divider class="my-4" />
  </template>
  <slot />
</template>

<script setup lang="ts">
import ContentTab from '~/components/@pages/content/ContentTab.vue'
import { CHAIN } from '~/constants/default.constants'

const route = useRoute()
const contentId = ref(route.params.contentId)

watchEffect(() => {
  contentId.value = route.params.contentId
})
</script>


<style scoped lang="scss">

</style>